import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RevenueReportService {
  constructor(private http: HttpClient) { }

  getRevenue(dateFrom: number, dateTo: number) {
    const body: any = {};
    if (dateFrom) body.dateFrom = dateFrom;
    if (dateTo) body.dateTo = dateTo;
    body.companyId = ["IbYFkxDI8RbMdRiukALO"];
    return this.http.post<any>(`${environment.apiUrl}/widgets/revenueReport`, body);
  }
}
